let isProd = false;

const getBaseUrl = () => {
  const hostname = window.location.hostname;

  if (isProd) {
    return "https://asempera.ro";
  }

  // If on localhost, use elconet.app
  if (hostname === "localhost" || hostname.includes("asempera.elconet.app")) {
    return "https://asempera.elconet.app";
  }

  // Otherwise use the current hostname
  return `https://asempera.ro`;
};

const baseUrl = getBaseUrl();

console.log("Base URL:", baseUrl);

export const BASE_URL = `${baseUrl}/`;
export const API_BASE_URL = `${baseUrl}/backend/api`;

export const API_TIMEOUT_MS = 15000;

export const BASE_FOLDER = "management";
